import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { List, ListItem, Typography } from '@mui/material';

export const Array = ({ value, code }) => {
    if (code === 'dates') {
        return (
            <Typography fontSize={'0.875rem !important'}>
                {value
                    ?.map(date =>
                        new Date(date).toLocaleString('ru-RU', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit',
                        })
                    )
                    .join(', ')}
            </Typography>
        );
    }
    return (
        <List sx={{ p: 0 }}>
            {value.map(item => (
                <ListItem
                    sx={{
                        display: 'flex',
                        justifyContent: 'start',
                        alignItems: 'center',
                        gap: 1,
                        p: 0,
                    }}
                >
                    {item.is_correct ? <CheckCircleIcon color="success" /> : <CancelIcon color="error" />}
                    <Typography>{item.option_text}</Typography>
                </ListItem>
            ))}
        </List>
    );
};
